export default __webpack_public_path__ + "static/media/profile.0ed91c86.svg";